// angular
import { Component, Input, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { AppService } from '../../../app.service';
import { MeRegisterService } from '../me-register.service';

@Component({
    selector: 'me-register-registration-privacy-card',
    templateUrl: './registration-privacy-card.component.html',
    styleUrls: ['./registration-privacy-card.component.scss'],
    encapsulation: ViewEncapsulation.None
})

export class MeRegistrationPrivacyCardComponent implements OnInit {
    data = null;
    url = 'register/registration-privacy-card';
    folder = 'core';

    constructor(
        public appService: AppService,
        public meRegisterService: MeRegisterService,
        public translate: TranslateService
    ) {

    }

    ngOnInit() {
        this.getContent();
        this.translate.onLangChange.subscribe(value => {
            this.getContent();
        });
    }

    getContent() {
        this.appService.getStoryBlokDataForClinic(this.url).subscribe(res => {
            this.data = res['story']['content'];
        });
    }

    gotoNext() {
        // Hide voucher code for now
        this.meRegisterService.step = 4;
    }
}
